export function useAppLoadingIndicator() {
    const manualLockCount = useState('app-loading-indicator-lock-count', () => 0);
    const { isLoading } = useLoadingIndicator();

    const isSpinnerVisible = computed(() => isLoading.value || manualLockCount.value > 0);

    function show() {
        manualLockCount.value++;

        let isReleased = false;

        return () => {
            if (isReleased) {
                return;
            }

            isReleased = true;
            manualLockCount.value--;
        };
    }

    return {
        isSpinnerVisible,
        show
    };
}
